import fi from './fi.json';
import en from './en.json';
import sv from './sv.json';

const translations = {
  'fi': {
    translation: fi
  },
  'en': {
    translation: en
  },
  'sv': {
    translation: sv
  }
};

export default translations;
